<template>
  <div id="itembank">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li><router-link :to="{path: '/tryouts'}">Tryout</router-link></li>
      <li class="active">Export Tryout</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Export Tryout</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
		  <div class="panel-heading">
            <div class="btn-group pull-right">
				<span>Tryout yang dipilih: {{$store.state.tryout.selectedTO.length}}</span> &nbsp;&nbsp;
				<button type="button" style="max-width:200px;" class="btn btn-success btn-xs" @click="submitExport()"><span class="fa fa-download"></span> Export to JSON</button>
            </div>
            <h4 class="panel-title">Export Tryout</h4>
          </div>
          <div class="panel-body" style="display:flex; flex-flow:column;">
            <app-datatable 
              :items="tryouts" 
              :headers="headers" 
							:has-action="false"
              :has-custom-pagination="true"
              :has-checkbox="true"
							:has-custom-search="true"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="pagination.perPage"
              :custom-pagination-total-pages="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"
              v-on:selected="selectedRow = $event"
              v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TryoutService from '@/services/tryout.js'
import DataTable from '@/components/plugins/DataTable'
import Moment from 'moment'
import Modal from '@/components/plugins/Modal'

export default {
	name: 'tryout',
	components: {
		'app-datatable': DataTable,
		'app-modal': Modal
	},
	data: function () {
		return {
			tryouts: [],
			selectedRow: null,
			search: null,
			exportModal: false,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			headers: ['Nama', 'Jenis', 'Jenjang', 'Tipe', 'Subtests'],
			headersKey: ['name', 'isRepeated', 'level', 'type', 'subtests'], // camel case for matching search with API
		}
	},
	watch: {
		pagination: function () {
            this.fetchData()
		},
	},
	mounted: function () {
		this.$store.commit('tryoutSelected', [])
		this.fetchData()
	},
	methods: {
		fetchData: function () {
			var context = this
			var search = this.search
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			}

			TryoutService.getListTryout(pagination, search, function (result) {
				context.tryouts = []

				if (result.success) {

					result.data.forEach(function (tryout) {
						var subtests = []
						var count = 0
						tryout.subtests.forEach(function (subtest) {
							subtests.push(subtest.subject_name);
							count += subtest.item_count
						})

						var createdAt = Moment(tryout.created_at).format('YYYY-MM-DD')
						var jenis = tryout.is_repeated ? "INSTANT" : "BERAGENDA"
						var row = {
							id: tryout.id,
							data: [
								// tryout.code,
								tryout.name,
								jenis,
								tryout.level,
								tryout.type,
								subtests.join(', '),
								// count,
								// tryout.duration,
								// tryout.status,
								// createdAt
							]
						}

						context.pagination.totalPages = tryout.page
						context.tryouts.push(row)
					})
				}
			})
    },
    submitExport() {
      if(this.$store.state.tryout.selectedTO.length < 1) {
        alert('tidak ada tryout yang dipilih')
      } else {
        TryoutService.exportTryout({"ids":this.$store.state.tryout.selectedTO}, function (result) {
        })
      }
       
    },
	createTryout: function () {
		this.$store.commit('tryout_reset')
		this.$router.push({ path: '/tryout-form' })
	},
	importTryout: function () {
		this.$router.push({ path: '/tryout-import' })
	},
	exportTryout: function () {
		this.$router.push({ path: '/tryout-export' })
	}
	}
}
</script>



// WEBPACK FOOTER //
// TryoutExport.vue?649687b2